export default __webpack_public_path__ + "static/media/scratch-card-white.dda9b84b.gif";